/** Mirrors escribonauta-projects `possibleProjectTypes` */
export const ProjectType = {
  NOVEL: 'novel',
  SHORT_STORY_ANTHOLOGY: 'short_story_anthology',
  POETRY_COLLECTION: 'poetry_collection',
  SCREENPLAY: 'screenplay',
} as const

export type ProjectTypeValue = (typeof ProjectType)[keyof typeof ProjectType]

export const PROJECT_TYPES: ProjectTypeValue[] = [
  ProjectType.NOVEL,
  ProjectType.SHORT_STORY_ANTHOLOGY,
  ProjectType.POETRY_COLLECTION,
  ProjectType.SCREENPLAY,
]

export function isKnownProjectType(type: string | undefined | null): type is ProjectTypeValue {
  return !!type && PROJECT_TYPES.includes(type as ProjectTypeValue)
}

export function normalizeProjectType(type: string | undefined | null): ProjectTypeValue {
  if (isKnownProjectType(type)) {
    return type
  }
  return ProjectType.NOVEL
}
